var _defs, _sodipodNamedview, _metadata;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: "425.38mm",
    height: "294.89999mm",
    viewBox: "0 0 425.38001 294.9",
    id: "svg5043",
    inkscapeVersion: "0.92.3 (2405546, 2018-03-11)",
    sodipodiDocname: "masts_nobg.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5037"
  })), _sodipodNamedview || (_sodipodNamedview = /*#__PURE__*/React.createElement("sodipodNamedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    inkscapeZoom: 0.49497475,
    inkscapeCx: -238.97361,
    inkscapeCy: 27.846924,
    "inkscapeDocument-units": "mm",
    "inkscapeCurrent-layer": "layer1",
    showgrid: "false",
    "inkscapeWindow-width": 3840,
    "inkscapeWindow-height": 2050,
    "inkscapeWindow-x": -12,
    "inkscapeWindow-y": -12,
    "inkscapeWindow-maximized": 1
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata5040"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Calque 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    transform: "translate(0,-2.0986397)"
  }, /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4742",
    d: "M 75.621948,197.78253 C 58.109849,186.0016 28.679906,185.52638 28.679906,185.52638 68.289214,146.99963 50.67473,112.12913 50.67473,112.12913 c 0,0 39.631747,5.5069 31.178439,46.0783 0,0 -8.257793,-4.88802 -16.901818,-2.40257 0,0 9.631824,11.76383 10.670597,41.97767 z",
    style: {
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccccccccccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4744",
    d: "m 162.78401,250.97681 h 81.244 l 13.95704,-16.53496 h 65.97302 c 0,14.35242 17.22947,13.26105 17.22947,13.26105 18.41995,0 22.52059,-9.22643 22.52059,-9.22643 l 4.23297,2.24866 c -8.99497,22.61992 -43.25542,37.97974 -43.25542,37.97974 -10.6658,4.36771 -12.56668,14.15399 -12.56668,14.15399 H 70.981833 C 70.91648,282.40872 63.04492,278.17573 63.04492,278.17573 48.692271,267.92406 50.478454,249.38952 50.478454,249.38952 l 1.455068,-26.72055 h 97.490218 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 2.96263266,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4746",
    d: "m 338.49404,136.8109 c 0,0 12.1578,36.8594 0.90078,72.81813 0,0 27.66042,-9.97067 62.78297,-1.0293 0,0 -34.28626,-55.32128 -63.68375,-71.78894 z",
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4748",
    d: "m 257.10758,178.59709 c 0,0 9.84204,14.66655 3.4737,44.83585 0,0 40.57978,-18.64563 74.23343,-1.60811 0,0 7.59055,-31.00558 -9.39174,-48.82418 0,0 -36.55541,-5.3201 -68.31539,5.59644 z",
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccccc",
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 262.63988,171.19944 c 0,0 35.91832,-13.61417 67.64551,-0.95087 0,0 5.99202,-24.2754 -7.43012,-41.64253 0,0 -32.95602,-4.07819 -60.39718,2.35824 0,0 6.54991,14.93308 0.18196,40.23537 z",
    id: "path4750",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccccc",
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 323.99425,125.39932 c 0,0 5.53065,-20.96488 -9.44415,-36.310872 0,0 -22.55533,-3.362263 -49.86875,1.239838 0,0 8.96221,18.728404 0.85721,36.799164 0,0 29.17301,-11.56092 58.45581,-1.72813 z",
    id: "path4752",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4754",
    d: "m 283.39812,78.472094 11.39232,0.03267 8.45253,-13.122719 -27.90506,-0.06535 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4756",
    d: "m 286.18745,52.595894 v 8.91077 h 5.91734 v -8.865241 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4758",
    d: "m 287.31718,220.20051 v 10.71689 h 7.10335 v -10.73932 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 164.88836,124.33702 c 0,0 9.84203,14.66655 3.47368,44.83585 0,0 40.57979,-18.64563 74.23344,-1.6081 0,0 7.59055,-31.00569 -9.39177,-48.82418 0,0 -36.55539,-5.3201 -68.31535,5.59643 z",
    id: "path4760",
    "inkscapeConnector-curvature": 0,
    sodipodNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4762",
    d: "m 170.42064,118.24543 c 0,0 36.6824,-13.61416 68.40959,-0.95087 0,0 3.36496,-22.750726 -8.19419,-41.642523 0,0 -32.95603,-4.078194 -60.39719,2.358235 0,0 6.54992,14.933087 0.18189,40.235378 z",
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    sodipodNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    id: "path4764",
    d: "m 231.77502,73.122037 c 0,0 5.53065,-20.964765 -9.44416,-36.310765 0,0 -22.17324,-3.362261 -49.48663,1.239841 0,0 8.96217,18.728411 0.8572,36.799052 0,0 28.7909,-11.560801 58.07368,-1.728128 z",
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    sodipodNodetypes: "cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 193.34401,32.522969 11.3923,0.03269 8.45254,-13.122718 -27.90505,-0.06535 z",
    id: "path4766",
    "inkscapeConnector-curvature": 0,
    sodipodNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 196.13335,6.6467713 v 8.9107707 h 5.91731 V 6.6922992 Z",
    id: "path4768",
    "inkscapeConnector-curvature": 0,
    sodipodNodetypes: "ccccc"
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4770",
    d: "m 72.308917,165.66869 c 0,0 9.014246,18.04166 3.473687,46.23689 0,0 40.579796,-18.64575 74.233446,-1.60821 0,0 7.59055,-32.40652 -9.39176,-50.22512 0,0 -31.33202,-8.02187 -68.315373,5.59644 z",
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccccc",
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 3.97559142,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 77.841198,159.67208 c 0,0 35.026712,-13.61417 66.753892,-0.95088 0,0 7.77516,-24.65749 -6.53849,-41.64252 0,0 -31.69515,-5.33905 -60.39719,2.35812 0,0 6.549925,14.93309 0.181888,40.23549 z",
    id: "path4772",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccccc",
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 139.19558,114.25394 c 0,0 5.53065,-20.964761 -9.44415,-36.310764 0,0 -21.79126,-3.36226 -49.104661,1.23984 0,0 8.962181,18.728415 0.857201,36.799054 0,0 28.40893,-11.5608 57.69172,-1.72813 z",
    id: "path4774",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4776",
    d: "m 98.599456,66.944621 11.392304,0.03267 8.45254,-13.122718 -27.905063,-0.06535 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4778",
    d: "m 101.3888,41.068532 v 8.91066 h 5.91731 v -8.865133 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#fdfde5",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 103.1532,207.71922 v 10.71689 h 7.10334 v -10.73944 z",
    id: "path4780",
    "inkscapeConnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4782",
    d: "m 196.96277,226.0223 v 18.21322 h 7.10335 v -18.23576 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4784",
    d: "m 163.34561,173.9964 c 0,0 7.60231,23.22976 1.23396,53.39916 0,0 41.43776,-14.71938 85.47129,-2.96731 0,0 5.60101,-31.60487 -11.30865,-54.03929 0,0 -33.25326,-12.06063 -75.3966,3.60744 z",
    style: {
      display: "inline",
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "ccccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4786",
    d: "m 27.466208,205.5406 11.831467,13.87143 c 0,0 -11.260942,-1.89477 -15.24492,4.57575 0,0 -3.249965,7.25975 -10.458092,8.35735 L 2.7015409,221.12557 c 0,0 7.5380481,-1.54372 10.8662171,-7.86775 0,0 3.483818,-8.27523 13.89845,-7.71722 z",
    style: {
      display: "inline",
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.61109066px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccc",
    "inkscapeConnector-curvature": 0,
    id: "path4788",
    d: "m 411.10033,203.29249 c -28.92903,-13.55493 -62.48312,-9.48511 -62.48312,-9.48511 0,0 14.77374,-24.3987 -7.07774,-73.61456 0,0 42.99694,36.70386 69.56086,83.09967 z",
    style: {
      fill: "#e3de0b",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 5.44601536,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodNodetypes: "cccccccc",
    "inkscapeConnector-curvature": 0,
    id: "path4790",
    d: "m 329.81854,237.55761 8.42129,5.92734 19.03459,-4.83072 8.21804,-5.77431 11.08742,1.21893 46.04345,-11.79825 -0.60449,-2.99291 z",
    style: {
      fill: "#f1f1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "2.88184977px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasts);
export default __webpack_public_path__ + "static/media/masts.e0f7de43360d2bc677f4ab52783af185.svg";
export { ForwardRef as ReactComponent };